import React, { useRef, useState, useEffect } from "react";
import { useNavigate }  from "react-router-dom";



const StanceContainer =  ({show=false, locationPath = "/", setLocationPath = (path: any) => {} , navigate = (path: any) => {} }) => {
  const [hidePage, setHidePage]  = useState(false);
  function returnTop() {
    setHidePage(true);
  }
  function removeHide(elm: any) {
    if(elm.target.classList.contains("main") && hidePage) {
      navigate("/");
      setHidePage(false);
    }
  }

  return (
         <div className={"container container-stance" + (locationPath === "/stance" ? " show" : "") + (hidePage ? " hide" : "" )}>
           <div className="side">
             <div className="sideLogo" onClick={() => returnTop()}><img src="img/sidelogo.png" alt="design creha" /></div>
             <div className="sideCatch sideCatch__stance"><img src="img/copy__stance.png" alt="黒衣のように" /></div>
             <div className="sideCopy">© Design CREHA all right reserved.</div>
           </div>
           <div className="main main__stance" onAnimationEnd={(e) => removeHide(e)}>
             <div className="mainClose" onClick={() => returnTop()}>
               <span></span>
               <span></span>
             </div>
             <div className="mainHead">STANCE</div>
             <div className="stanceBlock">
               <h2 className="stanceHead">デザイナーとして<br />果たすべき役割</h2>
               <p className="stanceDesc">グラフィックデザイナーとはどのような仕事ですか？と尋ねられた時、「クライアントと生活者の間を結ぶバイパス役です」と答えています。クライアントの要望を伺い、生活者の求めていることや最近の傾向などを考えたうえで、両者それぞれの立場に立ちながらデザインを整理し構築していくことが大切だからです。決してデザイナーとして我を通したり、一方的に「これしかないです！」と押しつけたりせず、むしろ逆に個性を出さず「黒衣（くろこ）」のように対応してくことが必要だと考えています。あくまでも最終的にはクライアントに喜んでいただくことが着地点ですので、自分好みのデザインやレイアウト、カラーリングなどにこだわり過ぎてしまうと、元々のベクトルから逸脱してしまいます。ものの考え方やアイデアそのものは個性を出しても構いませんが、デザイン自体に出してしまうのは望ましくありません。この辺がアートとは違う部分ですし、それが商業デザインなのです。<br /><br />そのような意味もあり、私たちはクライアントからの「ヒアリング」をとても大事にしています。何を望まれて、どのような方向で、何をやりたいのかを伺うのはもちろんですが、過去に行ってきたことや作ってきたイメージなど、今までの背景や会社としての考え方を知っておく必要があるからです。意外に感じられるかもしれませんが、そもそもデザイナーは白紙の状態からは何も生み出せませんし、生み出すべきでもありません。現状の築かれてきたものから今までと違う視点で新しいものを見出していくアシスト的役割が仕事だからです。ですからご提案するものは、クライアントのご要望・ご意見を十分に取り入れて、更に良くなっていくための土台であり、100％完璧なものではありません。<br />いっしょに作り上げていくお手伝いをしていきたい。<br />それが私たちの想いなのです。</p>
             </div>
           </div>
         </div>



  );
}

export default StanceContainer;
